import { useMemo } from 'react';
import { useRouter } from 'next/router';

export const useCinemaDetection = () => {
  const { pathname, query } = useRouter();
  const isCinema = useMemo(
    () =>
      !!pathname.split('/').find((segment) => segment.includes('cinema')) ||
      (pathname.includes('/library/video/') && query?.from === 'cinema'),
    [pathname]
  );

  return isCinema;
};
